import {Trigger} from '@radix-ui/react-dialog';
import {PropsWithChildren} from 'react';

type Props = PropsWithChildren;

export default function ModalTrigger({children}: Props) {
  return <Trigger asChild>{children}</Trigger>;
}
